import { Component } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { IconComponent } from '../../../components/icon/icon.component';
import { ModalCloseReason } from '../../../components/modal/modal.domain';
import { ButtonComponent } from '../../../components/button/button.component';
import { ModalCloseDirective } from '../../../components/modal/components/modal-close/modal-close-button.directive';

@Component({
  selector: 'td-wb-w8ben-success-message',
  templateUrl: 'w8ben-form-success-message.component.html',
  styleUrls: ['w8ben-form-success-message.component.scss'],
  imports: [
    IconComponent,
    ButtonComponent,
    ModalCloseDirective,
    TranslateDirective
  ]
})

export class W8BenFormSuccessMessageComponent {
  closeReason: ModalCloseReason = ModalCloseReason.ESC;
}

